function getProductInfoByHandle(productHandle, cb, errorCb) {
  if (!productHandle) {
    console.log("please provide a product handle");
    return;
  }
  fetch(window.Shopify.routes.root + "products/" + productHandle + ".js")
    .then((response) => response.json())
    .then((product) => {
      typeof cb === "function" && cb(product);
    })
    .catch((error) => {
      typeof errorCb === "function" && errorCb(error);
    });
}

function renderProductCard(product) {
  var productDomString = "";
  var learn_more_button_class = 'class="t4s-bl-item t4s-animation-none t4s-btn t4s-btn-custom t4s-pe-auto t4s-fnt-fm-inherit t4s-animation-none t4s-hidden-mobile-false t4s-btn-style-outline t4s-btn-effect-default"';
  var learn_more_button_style = 'style="--pri-cl: #c59852;--animation:none ;--delay-animation:0s;--button-icon-w:0px;--button-icon-w-mb:14px;--second-cl:#ffffff;--pri-cl-hover:#ffffff;--second-cl-hover:#222222;--button-fs:15px;--button-fw:500; --button-pd-lr:35px;--button-bdr:5px;--button-ls:0px;--button-mh:40px;--button-mgb:5px;--button-mgb-mb:0px;--button-fs-mb:14px;--button-mh-mb:34px;--button-pd-lr-mb:10px;--button-ls-mb:0px;"'

  productDomString =
    '<div class="append-product-card__container">' +
    '<div class="product-card__image">' +
    '<img src="' +
    product.featured_image +
    '" alt="' +
    product.featured_image +
    '">' +
    "</div>" +
    '<div class="append-product-card__info">' +
    "<div>" +
    '<div class="product-card__title">' +
    product.title +
    "</div>" +
    '<div class="product-card__price">' +
    getAppendProductPriceDom(product.variants[0]) +
    "</div>" +
    '<div class="product-card__description">' +
    product.description +
    "</div>" +
    "</div>" +
    '<div class="product-card__cta">' +
    '<a '+ learn_more_button_class + learn_more_button_style+' href="' +
    product.url +
    '">Learn more</a>';

  var availableVariant = getAvailableProductVariant(product);
  if (product.available && availableVariant) {
    var a_class = 'class="t4s-bl-item t4s-animation-none t4s-btn t4s-btn-custom t4s-pe-auto t4s-fnt-fm-inherit t4s-animation-none t4s-hidden-mobile-false t4s-btn-style-default t4s-btn-effect-default"';
    var a_style = 'style="color: #fff;--animation:none ;--delay-animation:0s;--button-icon-w:0px;--button-icon-w-mb:14px;--pri-cl:#c59852;--second-cl:#ffffff;--pri-cl-hover:#222222;--second-cl-hover:#ffffff;--button-fs:15px;--button-fw:500; --button-pd-lr:35px;--button-bdr:5px;--button-ls:0px;--button-mh:40px;--button-mgb:0px;--button-mgb-mb:0px;--button-fs-mb:14px;--button-mh-mb:34px;--button-pd-lr-mb:10px;--button-ls-mb:0px;"'
    productDomString +=
      '<a '+ a_class + a_style +' href="/cart/' +
      product.variants[0].id +
      ':1">Buy now</a>';
  }

  productDomString += "</div> </div> </div>";
  return productDomString;
}
function getAppendProductPriceDom(variantInfo) {
  var priceDom = "";
  if (variantInfo.compare_at_price > variantInfo.price) {
    priceDom = `<span class="price-old">${cart_currency_symbol.replace(
      "{{amount}}",
      (variantInfo.compare_at_price / 100).toFixed(2)
    )}</span><span class="price-last">${cart_currency_symbol.replace(
      "{{amount}}",
      (variantInfo.price / 100).toFixed(2)
    )}</span>`;
  } else {
    priceDom = `<span class="price-last">${cart_currency_symbol.replace(
      "{{amount}}",
      (variantInfo.price / 100).toFixed(2)
    )}</span>`;
  }

  return priceDom;
}
function getAvailableProductVariant(product) {
  return product.variants.find((variant) => variant.available);
}
function fastCheckout() {
  document.querySelector('[name="action_cart_redirect"]').value = "/checkout";
  document.querySelector('[name="add"]').click();
}
document.addEventListener("DOMContentLoaded", function () {
  var append_card_containers = document.querySelectorAll(
    ".append-product-card"
  );

  if (!append_card_containers.length) {
    console.log("No append-product-card containers found");
    return;
  }
  append_card_containers.forEach((card_container) => {
    var card_type = card_container.getAttribute("data-card-type");
    if (card_type === "product-card") {
      var product_handle = card_container.getAttribute("data-product-handle");

      getProductInfoByHandle(product_handle, function (product) {
        var card = $(
          '<div class="card">' + renderProductCard(product) + "</div>"
        );

        $(card).appendTo(card_container);
      });
    }
  });
});
